/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid values for a field-criterion field in a Query
 */
export enum BioSamplingContainerCriteriaFieldsV1 {
    CONTAINER_ID = 'CONTAINER_ID',
    CONTAINER_CODE = 'CONTAINER_CODE',
    CONTAINER_NUMBER = 'CONTAINER_NUMBER',
    CONTAINER_TYPE = 'CONTAINER_TYPE',
    KIT_CODE = 'KIT_CODE',
    KIT_TYPE = 'KIT_TYPE',
    PRACTICE_CODE = 'PRACTICE_CODE',
    EVENT_ID = 'EVENT_ID',
    D_CODE = 'D_CODE',
    SAMPLE_TYPE = 'SAMPLE_TYPE',
    LABEL_INFORMATION = 'LABEL_INFORMATION',
    RETURN_TYPE = 'RETURN_TYPE',
    SAMPLE_REQUIRED = 'SAMPLE_REQUIRED',
}